export const voidFunction = () => {
  return;
};
